import { Button as MUIButton } from '@mui/material';
import styled from 'styled-components';

import { IButton } from 'interfaces/component';

export const ButtonContainer = styled(MUIButton)<IButton>``;
